import api from './api';
import {prepareAgencyDetails} from '../../utils/helpers/agency';
import {isEmpty} from '../../utils/helpers/boolean';
import {
  preparePropertyProps,
  preparePropertyImages,
  preparePropertyListProps,
} from '../../utils/helpers/property';
import * as consts from '../../utils/constants/url';

const agencyApi = api.injectEndpoints({
  endpoints: build => ({
    initAgencyBySlug: build.query({
      query: slug => `${consts.API_PROPERTY_DETAILS}/${slug}`,
      transformResponse: results => {
        const {data} = results;
        const {agency, property, properties} = data;
        if (!isEmpty(property)) {
          return {
            ...data,
            prepared: {
              agency: prepareAgencyDetails(agency),
              property: {
                ...preparePropertyProps(property),
                images: preparePropertyImages(property.images),
              },
            },
          };
        }
        return {
          ...data,
          prepared: {
            agency: prepareAgencyDetails(agency),
            properties: preparePropertyListProps(properties),
          },
        };
      },
    }),
  }),
});

export const {useInitAgencyBySlugQuery} = agencyApi;

export default agencyApi;
